export const SPLIDE_SLIDER_CONFIG = {
    perPage: 1,
    perMove: 1,
    focus: "left",
    type: "slide",
    gap: "1.5rem",
    flickPower: 300,
    autoWidth: true,
    flickMaxPages: 1,
    arrows: "slider",
    pagination: false,
    speed: 600,
    classes: {
        arrows: "splide__arrows custom-arrows-1",
        arrow: "splide__arrow custom-arrow",
        prev: "splide__arrow--prev custom-arrow-prev",
        next: "splide__arrow--next custom-arrow-next"
    },
    drag: true,
    updateOnMove: true,
    trimSpace: true,
    breakpoints: {
        1230: {
            drag: true,
            perPage: 1,
            gap: "1rem"
        },
        991: {
            drag: true,
            perPage: 1,
            gap: "1rem"
        },
        767: {
            drag: true,
            perPage: 1,
            gap: "1rem"
        },
        479: {
            drag: true,
            perPage: 1,
            gap: ".5rem"
        }
    }
};
export const SPLIDE_NAV_CONFIG = (focus)=>({
        rewind: true,
        perPage: 1,
        padding: "0rem",
        perMove: 1,
        updateOnMove: true,
        isNavigation: true,
        autoWidth: true,
        flickMaxPages: 1,
        drag: false,
        snap: false,
        gap: 0,
        focus: focus || "center",
        pagination: false,
        cover: true,
        arrows: false,
        breakpoints: {
            1180: {
                autoWidth: true
            },
            991: {
                drag: "free"
            },
            767: {
                padding: "0",
                swipe: true,
                flickPower: 200,
                drag: "free"
            }
        }
    });
export const SPLIDE_CONTENT_CONFIG = {
    type: "fade",
    perPage: 1,
    perMove: 1,
    focus: "left",
    pagination: false,
    autoplay: false,
    interval: 4000,
    flickMaxPages: 1,
    drag: false,
    rewindSpeed: 0,
    speed: 600,
    cover: true,
    arrows: false
};
